import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

var isValidCanadianPostalCode = function (postCode, country) {
    if (!postCode || !country) {
        return true;
    }
    if (country !== Country.CANADA) {
        return true;
    }
    var canadianPostalCodeRegex = /^(?!.*[DFIOQUdfioqu])[A-VXYa-vxy][0-9][A-Za-z][ ]?[0-9][A-Za-z][0-9]$/;
    return canadianPostalCodeRegex.test(postCode);
};

export { isValidCanadianPostalCode };
